<template>
  <div id="app">
    <Index></Index>
  </div>
</template>

<script>
import Index from '@/views/Index.vue'

export default {
  name: 'app',
  components: {
    Index
  }
}
</script>